import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-12 bg-gray-700 overflow-y-scroll scrollbar-dark rounded shadow" }

import VuePdfEmbed from 'vue-pdf-embed';


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfViewer',
  props: {
  pdf: {
    type: String,
    required: true
  }
},
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VuePdfEmbed), {
      source: __props.pdf,
      class: "w-full space-y-12 shadow rounded mb-12"
    }, null, 8, ["source"])
  ]))
}
}

})